import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "reading-streak-widget16464__title-wrapper" }
const _hoisted_2 = { class: "reading-streak-widget16464__title" }
const _hoisted_3 = {
  key: 0,
  class: "reading-streak-widget16464__slot"
}
const _hoisted_4 = { class: "reading-streak-widget16464__subtitle-wrapper" }
const _hoisted_5 = { class: "reading-streak-widget16464__subtitle" }
const _hoisted_6 = { class: "reading-streak-widget16464__remaining-title" }

import { computed } from 'vue'

import { ReadingStreakData16464 } from '@/models/interfaces'

import ReadingStreakIcon16464 from './ReadingStreakIcon16464.vue'

const STREAK_GOAL_MINUTES = 10


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadingStreakWidget16464',
  props: {
    streakData: {}
  },
  setup(__props: any) {

const props = __props

const remainingMinutes = computed(() => {
  return Math.ceil(props.streakData.remaining_seconds / 60)
})

const elapsedTime = computed(() => {
  return Math.max(0, STREAK_GOAL_MINUTES - remainingMinutes.value)
})

const title = computed(() => {
  return props.streakData.streak_days > 0
    ? `${props.streakData.streak_days}-day streak`
    : 'Start your streak'
})

const subtitle = computed(() => {
  if (props.streakData.remaining_seconds <= 0) {
    return "You're awesome! Keep the streak tomorrow"
  }

  if (props.streakData.streak_days > 0) {
    return `Read ${STREAK_GOAL_MINUTES} minutes to keep your streak`
  }

  return remainingMinutes.value < STREAK_GOAL_MINUTES
    ? `Read ${STREAK_GOAL_MINUTES} minutes to complete your first streak`
    : `Read ${STREAK_GOAL_MINUTES} minutes to start your streak`
})

const remainingTimeLabel = computed(() => {
  return props.streakData.remaining_seconds > 0
    ? `${elapsedTime.value}/${STREAK_GOAL_MINUTES} min`
    : 'Done'
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'settings' },
    class: _normalizeClass(["reading-streak-widget16464", { 'reading-streak-widget16464--slotted': _ctx.$slots.default }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(title.value), 1),
        _createVNode(ReadingStreakIcon16464, {
          class: "reading-streak-widget16464__icon",
          active: __props.streakData.remaining_seconds <= 0
        }, null, 8, ["active"])
      ]),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(subtitle.value), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(remainingTimeLabel.value), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["reading-streak-widget16464__progress-bar", {
        'reading-streak-widget16464__progress-bar--full':
          elapsedTime.value >= STREAK_GOAL_MINUTES,
        'reading-streak-widget16464__progress-bar--empty': elapsedTime.value <= 0,
      }]),
        style: _normalizeStyle({
        '--streak-progress-position': elapsedTime.value,
        '--streak-goal-minutes': STREAK_GOAL_MINUTES,
      })
      }, null, 6)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})